document.addEventListener('DOMContentLoaded', function () {
  var galleryTrack = document.getElementById('gallery-mobile-track');
  var gallerySlides = Array.from(document.querySelectorAll('.gallery-slide'));
  var galleryThumbs = Array.from(document.querySelectorAll('.gallery-thumb'));
  var galleryCurrentIndex = document.getElementById('gallery-current-index');
  var galleryMainImg = document.getElementById('gallery-main-img');
  var desktopVariantMedia = document.getElementById('desktop-variant-media');
  var galleryPrev = document.getElementById('gallery-prev');
  var galleryNext = document.getElementById('gallery-next');
  var headerMenu = document.querySelector('.header-menu');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileNavCloseControls = Array.from(document.querySelectorAll('[data-mobile-nav-close]'));
  var mobileNavLinks = Array.from(document.querySelectorAll('.mobile-nav a'));

  var jarOptions = Array.from(document.querySelectorAll('.jar-option'));
  var bundleIncludes = document.getElementById('bundle-includes');
  var bundleGiftsBanner = document.querySelector('#bundle-gifts .bundle-gifts__banner');
  var bundleGiftsUnlocked = document.querySelector('#bundle-gifts .bundle-gifts__unlocked');
  var autoRefillToggle = document.getElementById('auto-refill-toggle');
  var autoRefillTitle = document.getElementById('auto-refill-title');
  var autoRefillSub = document.querySelector('.auto-refill__sub');

  var addToCartBtn = document.getElementById('add-to-cart');
  var checkoutCtas = Array.from(document.querySelectorAll('[data-checkout-cta]'));
  var checkoutRoutes = window.LulabitesCheckoutRoutes || window.LullaBitesCheckoutRoutes || {};
  var trackingApi = window.LulabitesAbTracking;
  var tracker = trackingApi && typeof trackingApi.createAbTracker === 'function'
    ? trackingApi.createAbTracker({
      endpoint: 'https://funnel-ab-dashboard.vercel.app/api/ab-track',
      testKey: 'lulabites_headline_v1'
    })
    : null;

  var accordionItems = document.querySelectorAll('[data-accordion]');
  var faqItems = document.querySelectorAll('[data-faq]');
  var seeAllBtn = document.getElementById('see-all-btn');
  var modal = document.getElementById('ingredients-modal');
  var modalClose = document.getElementById('modal-close');

  var resultsSlides = Array.from(document.querySelectorAll('.result-slide'));
  var avatarBtns = Array.from(document.querySelectorAll('.avatar-btn'));
  var dotsContainer = document.getElementById('carousel-dots');
  var dots = Array.from(dotsContainer ? dotsContainer.querySelectorAll('.dot') : []);
  var prevBtn = document.getElementById('results-prev');
  var nextBtn = document.getElementById('results-next');
  var resultsViewport = document.querySelector('.results-viewport');
  var benefitStrip = document.getElementById('benefit-strip');

  var videoThumbs = Array.from(document.querySelectorAll('.video-thumb, .media-play-tile'));
  var activeVideo = null;
  var ingredientsRow = document.getElementById('ingredients-row');
  var ingredientsPrev = document.getElementById('ingredients-prev');
  var ingredientsNext = document.getElementById('ingredients-next');

  var selectedOption = jarOptions.find(function (option) {
    return option.classList.contains('selected');
  }) || jarOptions[0];
  var jarToBundle = {
    '1': 'buy1',
    '2': 'buy2Get1',
    '3': 'buy3Get2'
  };
  var bundleAliases = {
    buy1: 'buy1',
    buy2Get1: 'buy2Get1',
    buy2get1free: 'buy2Get1',
    buy1Get1: 'buy2Get1',
    buy1get1free: 'buy2Get1',
    buy3Get2: 'buy3Get2',
    buy3get2free: 'buy3Get2',
    buy2Get2: 'buy3Get2',
    buy2get2free: 'buy3Get2'
  };
  var localCheckoutConfig = {
    variants: {
      buy1: 42630181421131,
      buy2Get1: 42630181453899,
      buy3Get2: 42630181486667
    },
    sellingPlans: {
      buy1: 1997635659,
      buy2Get1: 1997602891,
      buy3Get2: 1997668427
    },
    gifts: {
      sleepGuide: 43029410447435,
      sleepMask: 43029419622475
    }
  };

  function resolveLocalCartItem(purchaseType, bundleKey) {
    var normalizedBundleKey = bundleAliases[bundleKey] || 'buy1';
    var variantId = localCheckoutConfig.variants[normalizedBundleKey];
    var item = { id: variantId, quantity: 1 };

    if (purchaseType === 'subscription') {
      item.selling_plan = localCheckoutConfig.sellingPlans[normalizedBundleKey];
    }

    return item;
  }

  function resolveCheckoutCartItems(purchaseType, bundleKey) {
    var normalizedBundleKey = bundleAliases[bundleKey] || 'buy1';

    if (typeof checkoutRoutes.resolveCartItems === 'function') {
      return checkoutRoutes.resolveCartItems(purchaseType, normalizedBundleKey);
    }

    var mainItem = typeof checkoutRoutes.resolveCartItem === 'function'
      ? checkoutRoutes.resolveCartItem(purchaseType, normalizedBundleKey)
      : resolveLocalCartItem(purchaseType, normalizedBundleKey);
    var items = [mainItem];

    if (
      purchaseType === 'subscription' &&
      (normalizedBundleKey === 'buy2Get1' || normalizedBundleKey === 'buy3Get2')
    ) {
      items.push(
        { id: localCheckoutConfig.gifts.sleepGuide, quantity: 1 },
        { id: localCheckoutConfig.gifts.sleepMask, quantity: 1 }
      );
    }

    return items;
  }

  function resolveLocalCheckoutUrl(purchaseType, bundleKey) {
    var item = resolveLocalCartItem(purchaseType, bundleKey);
    var url = '/cart/' + item.id + ':1';

    return item.selling_plan ? url + '?selling_plan=' + item.selling_plan : url;
  }
  if (addToCartBtn && checkoutCtas.indexOf(addToCartBtn) === -1) {
    checkoutCtas.push(addToCartBtn);
  }

  function formatPrice(value) {
    var amount = Number(value);

    if (!isFinite(amount)) {
      return '';
    }

    return '$' + amount.toFixed(2);
  }

  function getPurchaseType() {
    return autoRefillToggle && autoRefillToggle.checked ? 'subscription' : 'oneTime';
  }

  function getSelectedBundleKey() {
    var currentSelectedOption = jarOptions.find(function (option) {
      return option.classList.contains('selected');
    }) || selectedOption;

    if (!currentSelectedOption) {
      return 'buy1';
    }

    var rawBundleKey = currentSelectedOption.dataset.option || currentSelectedOption.dataset.bundle || jarToBundle[currentSelectedOption.dataset.jar];

    return bundleAliases[rawBundleKey] || 'buy1';
  }

  function getCheckoutUrl() {
    var purchaseType = getPurchaseType();
    var bundleKey = getSelectedBundleKey();

    if (typeof checkoutRoutes.resolveCheckoutUrl === 'function') {
      try {
        return checkoutRoutes.resolveCheckoutUrl(purchaseType, bundleKey);
      } catch (error) {
        console.error('LullaBites checkout route error:', error);
      }
    }

    return resolveLocalCheckoutUrl(purchaseType, bundleKey);
  }

  function syncCheckoutCtas() {
    var purchaseType = getPurchaseType();
    var bundleKey = getSelectedBundleKey();
    var checkoutUrl = getCheckoutUrl();

    checkoutCtas.forEach(function (cta) {
      cta.dataset.checkoutUrl = checkoutUrl;
      cta.dataset.purchaseType = purchaseType;
      cta.dataset.bundle = bundleKey;
      cta.dataset.option = bundleKey;

      if (cta.tagName && cta.tagName.toLowerCase() === 'a') {
        cta.href = checkoutUrl;
      }
    });
  }

  function trackCheckoutClick(checkoutUrl, purchaseType, bundleKey) {
    if (!tracker) {
      return;
    }

    tracker.track('cta_click', {
      metadata: {
        checkout_url: checkoutUrl,
        purchase_type: purchaseType,
        bundle: bundleKey
      }
    });
  }

  function openMobileNav() {
    if (!mobileNav) {
      return;
    }

    mobileNav.hidden = false;
    document.body.classList.add('mobile-nav-open');

    if (headerMenu) {
      headerMenu.setAttribute('aria-expanded', 'true');
    }
  }

  function closeMobileNav() {
    if (!mobileNav) {
      return;
    }

    mobileNav.hidden = true;
    document.body.classList.remove('mobile-nav-open');

    if (headerMenu) {
      headerMenu.setAttribute('aria-expanded', 'false');
    }
  }

  function getInitialGalleryIndex() {
    var isMobileViewport = window.matchMedia
      ? window.matchMedia('(max-width: 1024px)').matches
      : window.innerWidth <= 1024;

    if (!isMobileViewport) {
      return 0;
    }

    var mobileStartSlide = document.querySelector('.gallery-slide[data-gallery-role="mobile-default"]');

    if (!mobileStartSlide) {
      return 0;
    }

    var explicitIndex = Number(mobileStartSlide.dataset.index);

    if (isFinite(explicitIndex)) {
      return explicitIndex;
    }

    return Math.max(0, gallerySlides.indexOf(mobileStartSlide));
  }

  function getVariantGalleryIndex() {
    var variantSlide = document.querySelector('.gallery-slide[data-gallery-role="variant"]');

    if (!variantSlide) {
      return 0;
    }

    var explicitIndex = Number(variantSlide.dataset.index);

    if (isFinite(explicitIndex)) {
      return explicitIndex;
    }

    return Math.max(0, gallerySlides.indexOf(variantSlide));
  }

  function getGallerySlideLeft(index) {
    if (!gallerySlides.length) {
      return 0;
    }

    var safeIndex = Math.max(0, Math.min(index, gallerySlides.length - 1));
    var firstOffset = gallerySlides[0] ? gallerySlides[0].offsetLeft : 0;
    var targetSlide = gallerySlides[safeIndex];

    if (!targetSlide) {
      return 0;
    }

    return Math.max(0, targetSlide.offsetLeft - firstOffset);
  }

  function getClosestGalleryIndex() {
    if (!galleryTrack || !gallerySlides.length) {
      return 0;
    }

    var currentLeft = galleryTrack.scrollLeft;
    var closestIndex = 0;
    var closestDistance = Infinity;

    gallerySlides.forEach(function (slide, slideIndex) {
      var distance = Math.abs(currentLeft - getGallerySlideLeft(slideIndex));

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = slideIndex;
      }
    });

    return closestIndex;
  }

  function updateGalleryUI(index) {
    if (!gallerySlides.length || !galleryThumbs.length) {
      return;
    }

    gallerySlides.forEach(function (slide, slideIndex) {
      slide.classList.toggle('is-active', slideIndex === index);
    });

    galleryThumbs.forEach(function (thumb, thumbIndex) {
      thumb.classList.toggle('active', thumbIndex === index);
      thumb.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false');
    });

    if (galleryCurrentIndex) {
      galleryCurrentIndex.textContent = String(index + 1);
    }
  }

  function goToGalleryIndex(index, behavior) {
    if (!galleryTrack || !gallerySlides.length) {
      return;
    }

    var safeIndex = Math.max(0, Math.min(index, gallerySlides.length - 1));

    galleryTrack.scrollTo({
      left: getGallerySlideLeft(safeIndex),
      behavior: behavior || 'smooth'
    });

    updateGalleryUI(safeIndex);
  }

  function syncGalleryFromScroll() {
    if (!galleryTrack || !gallerySlides.length) {
      return;
    }

    updateGalleryUI(getClosestGalleryIndex());
  }

  function updateVariantMedia(imageSrc) {
    if (!imageSrc) {
      return;
    }

    if (desktopVariantMedia) {
      desktopVariantMedia.src = imageSrc;
    }

    var variantSlide = document.querySelector('.gallery-slide[data-gallery-role="variant"] img');
    var variantThumb = document.querySelector('.gallery-thumb[data-gallery-role="variant"] img');

    if (galleryMainImg) {
      galleryMainImg.src = imageSrc;
    }

    if (variantSlide) {
      variantSlide.src = imageSrc;
    }

    if (variantThumb) {
      variantThumb.src = imageSrc;
    }
  }

  function updateBundleIncludes(option) {
    if (!option) {
      return;
    }

    var jarKey = option.dataset.jar || '1';
    var isBuyOne = jarKey === '1';
    var useSubscription = autoRefillToggle ? autoRefillToggle.checked : true;
    var showGiftImages = useSubscription && !isBuyOne;

    function setGiftPanelVisibility(element, shouldShow, visibleDisplay) {
      if (!element) {
        return;
      }

      element.hidden = !shouldShow;
      element.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      element.style.setProperty('display', shouldShow ? visibleDisplay : 'none', 'important');
    }

    if (bundleIncludes) {
      bundleIncludes.classList.remove(
        'bundle-includes--buy1',
        'bundle-includes--buy2',
        'bundle-includes--buy3'
      );
      bundleIncludes.classList.add('bundle-includes--buy' + jarKey);
      bundleIncludes.dataset.bundleState = jarKey;
      bundleIncludes.hidden = !showGiftImages;
      bundleIncludes.setAttribute('aria-hidden', showGiftImages ? 'false' : 'true');
      bundleIncludes.style.setProperty('display', showGiftImages ? 'grid' : 'none', 'important');
    }

    setGiftPanelVisibility(bundleGiftsBanner, !isBuyOne, 'inline-flex');
    setGiftPanelVisibility(bundleGiftsUnlocked, !isBuyOne, 'grid');

  }

  function renderJarPricing() {
    var useSubscription = autoRefillToggle ? autoRefillToggle.checked : true;

    jarOptions.forEach(function (option) {
      var current = option.querySelector('.price-current');
      var compare = option.querySelector('.price-compare');
      var daily = option.querySelector('.price-daily');
      var perJar = option.querySelector('.price-per-jar');
      var price = useSubscription ? option.dataset.subscription : option.dataset.regular;
      var comparePrice = useSubscription ? option.dataset.subscriptionCompare : option.dataset.regularCompare;
      var dailyPrice = useSubscription
        ? (option.dataset.subscriptionDaily || option.dataset.daily)
        : (option.dataset.regularDaily || option.dataset.daily);
      var perJarPrice = useSubscription
        ? option.dataset.subscriptionPerJar
        : option.dataset.regularPerJar;

      if (current) {
        current.textContent = formatPrice(price);
      }

      if (compare) {
        if (comparePrice) {
          compare.textContent = formatPrice(comparePrice);
          compare.style.display = 'inline-block';
        } else {
          compare.textContent = '';
          compare.style.display = 'none';
        }
      }

      if (daily) {
        if (dailyPrice && formatPrice(dailyPrice)) {
          daily.textContent = formatPrice(dailyPrice) + ' per day';
          daily.style.display = 'block';
        } else {
          daily.textContent = '';
          daily.style.display = 'none';
        }
      }

      if (perJar) {
        if (perJarPrice && formatPrice(perJarPrice)) {
          perJar.textContent = formatPrice(perJarPrice) + ' per jar';
          perJar.style.display = 'block';
        } else {
          perJar.textContent = '';
          perJar.style.display = 'none';
        }
      }
    });

    if (autoRefillSub) {
      autoRefillSub.textContent = useSubscription ? 'Cancel Anytime \u2013 No Commitment' : 'No automatic refills';
    }

    if (selectedOption) {
      updateVariantMedia(selectedOption.dataset.image);
      updateBundleIncludes(selectedOption);
    }

    syncCheckoutCtas();
  }

  function setSelectedOption(option) {
    selectedOption = option;

    jarOptions.forEach(function (item) {
      var isSelected = item === option;
      item.classList.toggle('selected', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    renderJarPricing();
    goToGalleryIndex(getVariantGalleryIndex(), 'smooth');
  }

  jarOptions.forEach(function (option) {
    option.setAttribute('aria-pressed', option.classList.contains('selected') ? 'true' : 'false');
    option.addEventListener('click', function () {
      setSelectedOption(option);
    });
  });

  if (autoRefillToggle) {
    autoRefillToggle.addEventListener('change', renderJarPricing);
  }

  renderJarPricing();

  if (tracker) {
    tracker.track('page_view');
  }

  if (headerMenu && mobileNav) {
    headerMenu.addEventListener('click', function () {
      if (mobileNav.hidden) {
        openMobileNav();
      } else {
        closeMobileNav();
      }
    });
  }

  mobileNavCloseControls.forEach(function (control) {
    control.addEventListener('click', closeMobileNav);
  });

  mobileNavLinks.forEach(function (link) {
    link.addEventListener('click', closeMobileNav);
  });

  if (galleryTrack) {
    galleryTrack.addEventListener('scroll', syncGalleryFromScroll, { passive: true });
  }

  galleryThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      goToGalleryIndex(Number(thumb.dataset.index), 'smooth');
    });
  });

  if (galleryPrev) {
    galleryPrev.addEventListener('click', function () {
      var activeIndex = gallerySlides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      goToGalleryIndex(Math.max(0, activeIndex - 1), 'smooth');
    });
  }

  if (galleryNext) {
    galleryNext.addEventListener('click', function () {
      var activeIndex = gallerySlides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      goToGalleryIndex(Math.min(gallerySlides.length - 1, activeIndex + 1), 'smooth');
    });
  }

  window.addEventListener('resize', function () {
    syncGalleryFromScroll();

    if (window.innerWidth > 1024) {
      closeMobileNav();
    }
  });

  var initialGalleryIndex = getInitialGalleryIndex();
  updateGalleryUI(initialGalleryIndex);
  window.setTimeout(function () {
    goToGalleryIndex(initialGalleryIndex, 'auto');
  }, 180);

  if (addToCartBtn) {
  addToCartBtn.addEventListener('click', function (event) {
    if (addToCartBtn.disabled) {
      return;
    }

    event.preventDefault();
    syncCheckoutCtas();

    var purchaseType = getPurchaseType();
    var bundleKey = getSelectedBundleKey();
    var checkoutUrl = getCheckoutUrl();

    console.log('purchaseType:', purchaseType);
    console.log('bundleKey:', bundleKey);
    console.log('checkoutUrl:', checkoutUrl);

    trackCheckoutClick(checkoutUrl, purchaseType, bundleKey);

    var items;

    try {
      items = resolveCheckoutCartItems(purchaseType, bundleKey);
    } catch (routeError) {
      console.error('No LullaBites variant is configured for:', bundleKey, routeError);
      alert(routeError.message || 'This bundle is not configured yet. Please select another option or contact support.');
      return;
    }

    addToCartBtn.disabled = true;
    addToCartBtn.setAttribute('aria-busy', 'true');

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (clearResponse) {
        if (!clearResponse.ok) {
          throw new Error('The cart could not be cleared.');
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'This bundle could not be added.');
          }

          window.location.assign('/checkout');
        });
      })
      .catch(function (error) {
        console.error('LullaBites checkout failed:', error);
        alert(error.message || 'Unable to start checkout. Please try again.');
        addToCartBtn.disabled = false;
        addToCartBtn.removeAttribute('aria-busy');
      });
  });
}

  accordionItems.forEach(function (item) {
    var header = item.querySelector('.accordion-header');
    var body = item.querySelector('.accordion-body');
    var icon = item.querySelector('.accordion-icon');

    if (!header || !body) {
      return;
    }

    header.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');

      item.classList.toggle('open', !isOpen);
      body.style.display = isOpen ? 'none' : 'block';
      header.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

      if (icon) {
        icon.textContent = isOpen ? '+' : '\u2212';
      }
    });
  });

  faqItems.forEach(function (item) {
    var question = item.querySelector('.faq-question');
    var answer = item.querySelector('.faq-answer');

    if (!question || !answer) {
      return;
    }

    question.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      item.classList.toggle('open', !isOpen);
      answer.style.display = isOpen ? 'none' : 'block';
    });
  });

  if (seeAllBtn && modal) {
    seeAllBtn.addEventListener('click', function () {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });
  }

  if (modalClose && modal) {
    modalClose.addEventListener('click', function () {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    });
  }

  if (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMobileNav();
    }

    if (event.key === 'Escape' && modal && modal.style.display === 'flex') {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  });

  function getResultsCardsPerPage() {
    if (window.innerWidth <= 768) {
      return 1;
    }

    return 2;
  }

  function getResultsMaxPage() {
    return Math.max(0, resultsSlides.length - getResultsCardsPerPage());
  }

  function syncResultDots() {
    if (!dotsContainer) {
      return;
    }

    var requiredDots = getResultsMaxPage() + 1;
    var dotMarkup = '';
    var dotIndex = 0;

    for (dotIndex = 0; dotIndex < requiredDots; dotIndex += 1) {
      dotMarkup += '<span class="dot' + (dotIndex === 0 ? ' active' : '') + '" data-dot="' + dotIndex + '"></span>';
    }

    dotsContainer.innerHTML = dotMarkup;
    dots = Array.from(dotsContainer.querySelectorAll('.dot'));
  }

  function setActiveResultAvatar(index) {
    avatarBtns.forEach(function (btn, btnIndex) {
      btn.classList.toggle('active', btnIndex === index);
    });
  }

  function setActiveResultDot(index) {
    dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('active', dotIndex === index);
    });
  }

  function showResultSlide(index, activeAvatarIndex) {
    if (!resultsSlides.length || !resultsViewport) {
      return 0;
    }

    var safePage = Math.max(0, Math.min(index, getResultsMaxPage()));
    var slidesTrack = document.getElementById('results-slides');
    var targetSlide = resultsSlides[safePage];
    var maxTranslate = Math.max(0, slidesTrack.scrollWidth - resultsViewport.clientWidth);
    var translateX = targetSlide ? Math.min(targetSlide.offsetLeft, maxTranslate) : 0;

    slidesTrack.style.transform = 'translateX(-' + translateX + 'px)';

    resultsSlides.forEach(function (slide, slideIndex) {
      slide.classList.toggle('active', slideIndex === (activeAvatarIndex != null ? activeAvatarIndex : safePage));
    });

    setActiveResultAvatar(activeAvatarIndex != null ? activeAvatarIndex : safePage);
    setActiveResultDot(safePage);

    return safePage;
  }

  var currentResultSlide = 0;
  var currentActiveAvatar = 0;

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      currentResultSlide = currentResultSlide <= 0 ? getResultsMaxPage() : currentResultSlide - 1;
      currentActiveAvatar = currentResultSlide;
      showResultSlide(currentResultSlide, currentActiveAvatar);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      currentResultSlide = currentResultSlide >= getResultsMaxPage() ? 0 : currentResultSlide + 1;
      currentActiveAvatar = currentResultSlide;
      showResultSlide(currentResultSlide, currentActiveAvatar);
    });
  }

  avatarBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var avatarIndex = Number(btn.dataset.slide);
      currentActiveAvatar = avatarIndex;
      currentResultSlide = Math.min(avatarIndex, getResultsMaxPage());
      showResultSlide(currentResultSlide, currentActiveAvatar);
    });
  });

  if (dotsContainer) {
    dotsContainer.addEventListener('click', function (event) {
      var dot = event.target.closest('.dot');

      if (!dot) {
        return;
      }

      currentResultSlide = Number(dot.dataset.dot);
      currentActiveAvatar = Math.min(currentResultSlide, resultsSlides.length - 1);
      showResultSlide(currentResultSlide, currentActiveAvatar);
    });
  }

  var resultsAutoplay = window.setInterval(function () {
    currentResultSlide = currentResultSlide >= getResultsMaxPage() ? 0 : currentResultSlide + 1;
    currentActiveAvatar = currentResultSlide;
    showResultSlide(currentResultSlide, currentActiveAvatar);
  }, 6500);

  var resultsCarousel = document.getElementById('results-carousel');
  if (resultsCarousel) {
    resultsCarousel.addEventListener('mouseenter', function () {
      window.clearInterval(resultsAutoplay);
    });

    resultsCarousel.addEventListener('mouseleave', function () {
      window.clearInterval(resultsAutoplay);
      resultsAutoplay = window.setInterval(function () {
        currentResultSlide = currentResultSlide >= getResultsMaxPage() ? 0 : currentResultSlide + 1;
        currentActiveAvatar = currentResultSlide;
        showResultSlide(currentResultSlide, currentActiveAvatar);
      }, 6500);
    });
  }

  window.addEventListener('resize', function () {
    syncResultDots();
    currentResultSlide = Math.min(currentResultSlide, getResultsMaxPage());
    currentActiveAvatar = Math.min(currentActiveAvatar, resultsSlides.length - 1);
    showResultSlide(currentResultSlide, currentActiveAvatar);
  });

  syncResultDots();
  showResultSlide(0, 0);

  function initVideoCards(cards) {
    cards.forEach(function (thumb) {
      var video = thumb.querySelector('video');

      if (!video) {
        return;
      }

      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.removeAttribute('autoplay');
      video.pause();

      thumb.addEventListener('click', function () {
        var isPlaying = !video.paused;

        if (isPlaying) {
          video.pause();
          thumb.classList.remove('is-playing');
          if (activeVideo === video) {
            activeVideo = null;
          }
        } else {
          if (activeVideo && activeVideo !== video) {
            activeVideo.pause();
          }

          video.muted = false;
          video.removeAttribute('muted');
          video.volume = 1;
          video.play().catch(function () {
            return null;
          });
          activeVideo = video;
          thumb.classList.add('is-playing');
        }
      });

      video.addEventListener('pause', function () {
        thumb.classList.remove('is-playing');
        if (activeVideo === video) {
          activeVideo = null;
        }
      });

      video.addEventListener('play', function () {
        if (activeVideo && activeVideo !== video) {
          activeVideo.pause();
        }
        activeVideo = video;
        thumb.classList.add('is-playing');
      });
    });
  }

  function setVideoPosterFromFirstFrame(video) {
    if (!video || video.getAttribute('poster')) {
      return;
    }

    var posterCaptured = false;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');

    if (!context) {
      return;
    }

    function capturePosterFrame() {
      if (posterCaptured || !video.videoWidth || !video.videoHeight) {
        return;
      }

      posterCaptured = true;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      try {
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        video.setAttribute('poster', canvas.toDataURL('image/jpeg', 0.82));
      } catch (error) {
        // Ignore poster generation failures and fall back to native behavior.
      }
    }

    function tryCaptureAtStartFrame() {
      if (!video.videoWidth || !video.videoHeight) {
        return;
      }

      if (video.readyState >= 2) {
        if (video.duration && isFinite(video.duration) && video.duration > 0.08) {
          var onSeeked = function () {
            video.removeEventListener('seeked', onSeeked);
            capturePosterFrame();
            video.currentTime = 0;
          };

          video.addEventListener('seeked', onSeeked, { once: true });

          try {
            video.currentTime = 0.08;
          } catch (error) {
            capturePosterFrame();
          }
        } else {
          capturePosterFrame();
        }
      }
    }

    if (video.readyState >= 1) {
      tryCaptureAtStartFrame();
    } else {
      video.addEventListener('loadedmetadata', tryCaptureAtStartFrame, { once: true });
    }

    video.addEventListener('loadeddata', capturePosterFrame, { once: true });
  }

  function initVideoPosters() {
    var pageVideos = Array.from(document.querySelectorAll('.video-thumb video, .media-play-tile video'));
    pageVideos.forEach(function (video) {
      setVideoPosterFromFirstFrame(video);
    });
  }

  initVideoPosters();
  initVideoCards(videoThumbs);

  if (ingredientsRow) {
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    function getIngredientsScrollAmount() {
      var firstCard = ingredientsRow.querySelector('.ingredient-card');
      var cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 168;
      return Math.max(cardWidth + 16, ingredientsRow.clientWidth * 0.72);
    }

    function updateIngredientsArrows() {
      var maxScroll = Math.max(0, ingredientsRow.scrollWidth - ingredientsRow.clientWidth - 2);

      if (ingredientsPrev) {
        ingredientsPrev.disabled = ingredientsRow.scrollLeft <= 2;
      }

      if (ingredientsNext) {
        ingredientsNext.disabled = ingredientsRow.scrollLeft >= maxScroll;
      }
    }

    function scrollIngredients(direction) {
      ingredientsRow.scrollBy({
        left: getIngredientsScrollAmount() * direction,
        behavior: 'smooth'
      });
    }

    if (ingredientsPrev) {
      ingredientsPrev.addEventListener('click', function () {
        scrollIngredients(-1);
      });
    }

    if (ingredientsNext) {
      ingredientsNext.addEventListener('click', function () {
        scrollIngredients(1);
      });
    }

    ingredientsRow.addEventListener('mousedown', function (event) {
      isDown = true;
      startX = event.pageX - ingredientsRow.offsetLeft;
      scrollLeft = ingredientsRow.scrollLeft;
      ingredientsRow.style.cursor = 'grabbing';
    });

    ingredientsRow.addEventListener('mouseleave', function () {
      isDown = false;
      ingredientsRow.style.cursor = '';
    });

    ingredientsRow.addEventListener('mouseup', function () {
      isDown = false;
      ingredientsRow.style.cursor = '';
    });

    ingredientsRow.addEventListener('mousemove', function (event) {
      if (!isDown) {
        return;
      }

      event.preventDefault();
      var x = event.pageX - ingredientsRow.offsetLeft;
      var walk = (x - startX) * 2;
      ingredientsRow.scrollLeft = scrollLeft - walk;
    });

    ingredientsRow.addEventListener('scroll', updateIngredientsArrows, { passive: true });
    window.addEventListener('resize', updateIngredientsArrows);
    window.requestAnimationFrame(updateIngredientsArrows);
  }

  if (benefitStrip) {
    var benefitStripHovered = false;
    var benefitStripInView = false;

    function syncBenefitStripState(isInView) {
      benefitStripInView = Boolean(isInView);
      benefitStrip.classList.toggle('is-animating', benefitStripInView && !benefitStripHovered);
      benefitStrip.classList.toggle('is-paused', benefitStripHovered);
      benefitStrip.dataset.inView = benefitStripInView ? 'true' : 'false';
    }

    function updateBenefitStripVisibility() {
      var rect = benefitStrip.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
      var isInView = visibleHeight > Math.min(rect.height * 0.15, 80);

      syncBenefitStripState(isInView);
    }

    benefitStrip.addEventListener('mouseenter', function () {
      benefitStripHovered = true;
      syncBenefitStripState(benefitStripInView);
    });

    benefitStrip.addEventListener('mouseleave', function () {
      benefitStripHovered = false;
      syncBenefitStripState(benefitStripInView);
    });

    if ('IntersectionObserver' in window) {
      var benefitStripObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var isInView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          syncBenefitStripState(isInView);
        });
      }, {
        threshold: 0.15
      });

      benefitStripObserver.observe(benefitStrip);
    }

    window.addEventListener('scroll', updateBenefitStripVisibility, { passive: true });
    window.addEventListener('resize', updateBenefitStripVisibility);
    window.requestAnimationFrame(updateBenefitStripVisibility);
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var href = link.getAttribute('href');
      var target = null;

      if (!href || href === '#') {
        event.preventDefault();
        return;
      }

      try {
        target = document.querySelector(href);
      } catch (error) {
        target = null;
      }

      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});

/* Independent rotating social-proof notice */
(function () {
  var messages = [
    { icon: '\uD83D\uDED2', text: 'Currently in the cart of 72+ people!' },
    { icon: '\uD83D\uDE80', text: 'Hurry up! Less than 50 bottles in stock!' },
    { icon: '\uD83D\uDC40', text: '7,562 people viewed in the last 24 hours!' }
  ];

  function initializeUrgencyNotices() {
    var notices = Array.from(document.querySelectorAll('.urgency-line'));

    notices.forEach(function (notice) {
      var icon = notice.querySelector('.urgency-icon');
      var text = notice.querySelector('.urgency-text');
      var messageIndex = 0;

      if (!icon || !text || notice.dataset.rotationReady === 'true') {
        return;
      }

      notice.dataset.rotationReady = 'true';
      icon.textContent = messages[0].icon;
      text.textContent = messages[0].text;

      window.setInterval(function () {
        messageIndex = (messageIndex + 1) % messages.length;
        notice.classList.add('is-changing');

        window.setTimeout(function () {
          icon.textContent = messages[messageIndex].icon;
          text.textContent = messages[messageIndex].text;
          notice.classList.remove('is-changing');
        }, 160);
      }, 3200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeUrgencyNotices);
  } else {
    initializeUrgencyNotices();
  }

  document.addEventListener('shopify:section:load', initializeUrgencyNotices);
})();
